import { Controller } from "@hotwired/stimulus";

var DataReportsFilterController = class extends Controller {
  connect() {
    this.syncYearLabel();
    this.syncEventLabel();
  }

  yearChanged() {
    if (this.hasEventSelectTarget) {
      this.eventSelectTarget.value = "";
    }

    this.syncYearLabel();
    this.syncEventLabel();
    this.submit();
  }

  eventChanged() {
    this.syncEventLabel();
    this.submit();
  }

  syncYearLabel() {
    if (this.hasYearLabelTarget && this.hasYearSelectTarget) {
      this.yearLabelTarget.textContent = this.selectedOptionText(
        this.yearSelectTarget,
      );
    }
  }

  syncEventLabel() {
    if (this.hasEventLabelTarget && this.hasEventSelectTarget) {
      this.eventLabelTarget.textContent = this.selectedOptionText(
        this.eventSelectTarget,
      );
    }
  }

  selectedOptionText(select) {
    var selectedOption = select.options[select.selectedIndex];
    return selectedOption ? selectedOption.text : "";
  }

  submit() {
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }
};

DataReportsFilterController.targets = [
  "yearSelect",
  "eventSelect",
  "yearLabel",
  "eventLabel",
];

export default DataReportsFilterController;
